import { createSelector } from 'reselect'

export const selectHldOnnxNames = createSelector(
  [ state => state.nabletHld.onnxNames ],
  onnxNames => onnxNames as Array<string>
)
